// GAVION full-email: « Voir le courriel » from the CRM's stored copy, and the mailbox archive (admins).
export const emailArchiveEn = {
  viewer: {
    archived_on: "Copy archived on %{date}",
    truncated: "message truncated (too long)",
    pending: "The full copy is being saved.",
    download: "Download %{name}",
    not_kept: "not kept: %{reason}",
    reasons: {
      pending: "being saved",
      skipped_inline: "embedded image",
      skipped_type: "file type not kept",
      skipped_size: "too large",
      skipped_cap: "too large",
      skipped_item: "Outlook attachment",
      failed: "could not be saved",
    },
  },
  card: {
    title: "Mailbox archive",
    description:
      "Keeps in the CRM, in full, the emails linked to a company or contact of a rep who left. The mailbox is read with your Microsoft account, through delegation.",
    source: "Mailbox to archive",
    source_none: "No disabled user.",
    mailbox: "Mailbox: %{email}",
    mailbox_unknown:
      "The CRM does not know this mailbox's Microsoft id (this rep never connected Outlook in the CRM).",
    reconnect: "Reconnect Outlook (new « Read shared mailboxes » permission).",
    step1: "Step 1 — Delegation",
    delegation_1:
      "Microsoft 365 admin center → Users → Active users → %{name}.",
    delegation_2: "Keep the licence. Choose « Block sign-in ».",
    delegation_3:
      "Mail → Mailbox permissions → « Read and manage (Full Access) » → add the Microsoft account connected to the CRM.",
    delegation_4:
      "Wait up to 60 minutes, then check the access here. Do not convert or delete the mailbox before the end.",
    confirm_delegation:
      "I gave my Microsoft account full access to %{name}'s mailbox",
    check: "Check access",
    folders: "%{smart_count} folder found |||| %{smart_count} folders found",
    folder_row: "%{name} — %{total} items",
    step2: "Step 2 — Start the archive",
    start: "Start the archive",
    confirm_title: "Start the archive?",
    confirm_body:
      "Only the emails linked to a CRM company or contact will be kept, in full, under %{name}'s name. The others are not copied.",
    status: {
      checking: "Checking",
      ready: "Ready",
      running: "Running",
      paused: "Paused",
      blocked: "Blocked",
      done: "Done",
      cancelled: "Cancelled",
    },
    counts: {
      seen: "Seen",
      archived: "Archived",
      already_in_crm: "Already in the CRM",
      skipped_unlinked: "Not linked (ignored)",
      skipped_ignored: "Ignored (invitations, sent to self)",
      skipped_retention: "Ignored — retention period exceeded",
      private: "Private",
      failed: "Failures",
      pending: "Copies waiting",
      stored: "Copies saved",
      files: "Attachments kept",
      bytes: "Size kept",
    },
    folder_progress: "%{name}: %{seen} / %{total}",
    folder_gone: "%{name}: %{seen} / %{total} (folder vanished, skipped)",
    pause: "Pause",
    resume: "Resume",
    cancel: "Cancel",
    retry_failed: "Retry failures",
    cancel_title: "Cancel the archive?",
    cancel_body: "What is already saved is kept.",
    report: "Final report",
    duration: "Duration: %{minutes} min",
    failures: "Failures by code",
    failure_forbidden: "Access denied by Microsoft",
    online_archive:
      "The Exchange online archive cannot be read through Microsoft Graph: if the admin center shows one, it is not copied.",
    license_hint:
      "Once « Done » and the report read, you may remove the licence and the full access.",
  },
  errors: {
    forbidden: "Administrators only.",
    unauthorized: "Session expired: sign in to the CRM again.",
    m365_not_configured: "Microsoft 365 is not configured for the CRM yet.",
    archive_failed:
      "The archive failed unexpectedly: try again or contact support.",
    archive_rpc_failed:
      "The CRM could not save the archive progress: try again in a moment.",
    invalid_mailbox:
      "Invalid mailbox id: the archive cannot read this mailbox.",
    db_unavailable: "The database is unavailable: try again in a moment.",
    reader_not_admin:
      "The connected Microsoft account is no longer an administrator's: reconnect with an administrator account.",
    attachment_too_large: "An attachment is too large to be kept.",
    job_not_running: "The archive is not running.",
    method_not_allowed: "Action not allowed.",
    graph_timeout: "Microsoft took too long to answer: try again in a moment.",
    source_active: "This rep is still active: disable them first.",
    reader_not_connected: "Connect your Microsoft 365 account first.",
    mailbox_unknown:
      "The CRM does not know this mailbox's Microsoft id (this rep never connected Outlook in the CRM).",
    invalid_body: "Invalid request.",
    job_open: "An archive is already open for this mailbox.",
    not_found: "Not found.",
    invalid_state: "This action is not possible right now.",
    scope_missing:
      "Reconnect Outlook (new « Read shared mailboxes » permission).",
    delegation_missing:
      "Access denied: your Microsoft account does not have full access to %{name}'s mailbox (delegation missing or not active yet — up to 60 min).",
    mailbox_not_found: "Mailbox not found (licence removed?).",
    microsoft_needs_reauth:
      "Your Microsoft connection expired: reconnect Outlook.",
    reader_needs_reauth:
      "Your Microsoft connection expired: reconnect Outlook, then « Resume ».",
    too_many_folders:
      "More than 200 folders: the archive cannot walk them all.",
    no_folders: "No folder to archive.",
    graph_throttled: "Microsoft is throttling requests: try again in a moment.",
    graph_unavailable: "Microsoft is unavailable: try again in a moment.",
    unknown: "Unexpected error.",
    storage_upload_failed:
      "An attachment could not be saved in the CRM: try again later.",
    attachment_unsupported: "Attachment type not kept.",
  },
};
